/*
 * Base table with pagination
 *
 * @param {String} url Api endpoint
 * @param {Array} columns Table's columns
 * @param {Boolean} isSearchable Have search field or not
 * @param {Int} maxRows Limit records in one page
 *
 * @return {Element}
 */
<template>
  <div class="">
    <div class="flexbox m-b-md justify-between gap-20 box-base-table-search" v-if="isSearchable">
      <div>
        <label for="allCheck" v-if="isShowBtnBulkDelete && defaultData.length > 0">
          <input type="checkbox" id="allCheck" v-model="checkAll" @click="$emit('checkBoxAll', checkAll)"> 全選択
        </label>
        <button v-if="isShowBtnBulkDelete" type="button" class="btn btn-info w-200" :disabled="checkedItems.length === 0" @click="$emit('confirmDelete')">選択した商品を削除</button>
      </div>
      <div class="flexbox justify-right gap-10" style="width: 50%;">
        <div class="flex flex-grow gap-10">
          <input type="text" class="form-control text-center" v-model.trim="search" @keydown.enter="onHandleSearchWithEnter">
          <button class="btn btn-warning ver-middle w-120" @click="onHandleSearch">フィルター</button>
        </div>
        <pagination
          :totalPage="totalPage"
          :currentPage="currentPage"
          :paginationStorageKey="paginationStorageKey"
          @updateCurrentPage="updateCurrentPage"
        />
      </div>
    </div>
    <pagination
      v-else
      class="flexbox justify-right mr-b-10"
      :totalPage="totalPage"
      :currentPage="currentPage"
      :paginationStorageKey="paginationStorageKey"
      @updateCurrentPage="updateCurrentPage"
    />
    <div class="table-wrapper" ref="table">
      <table class="table table-bordered common-table widthedTable" :class="tableClass">
        <thead>
          <tr class="align-middle">
            <th
              v-for="(column, index) in columns"
              :class="[{ 'pointer-cursor': isSortable(column.sortable)}, column.headerClass]"
              :key="index"
              :style="{width: column.width}"
              @click="sortColumn(column.name, column.sortable, column.customSort)"
              v-html="renderTitle(column)"
            >
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!initial && countTableData() === 0">
            <td :colspan="columns.length" align="center" class="bg-danger text-danger"><h5 style="font-weight: 600">データが見つかりません。</h5></td>
          </tr>
          <tr v-for="(item, index) in pageData" :key="index" :class="bgColor(item.judgmentStatusCode)" @click="selectRowRequest(item)" v-else>
            <td
              v-for="(column, colIndex) in columns"
              :key="index + '-' + colIndex"
              :class="column.cellClass"
              :style="{width: column.width}"
            >
              <template v-if="column.customCell">
                <slot :name="column.name" :row-data="item" :data="defaultData" :handle-data="handleData" :original-data="originalData"></slot>
                <details v-if="column.detailAmountCell">
                  <summary class='text-left'>内訳</summary>
                  <p>{{ item.amountDetails }}</p>
                </details>
                <details v-if="column.detailTransactionCell">
                  <summary class='text-left'>内訳</summary>
                  <p>{{ item.transactionDetails }}</p>
                </details>
              </template>
              <template v-else>
                <span>
                  {{ item[column.name] }}
                </span>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
      <get-data
        :url="this.url"
        :extraUrl="this.extraUrl"
        :extraUrlMode="this.extraUrlMode"
        @onChangePage="onChangePage"
        @zIndex="$emit('zIndex', $event)"
        :keyword="this.keyword"
        :maxRows="maxRows"
        :method="method"
        ref="pagination"
        @updateTotalPage="updateTotalPage"
        :currentPage="currentPage"
        @updateCurrentPage="updateCurrentPage"
        @originalData="getOriginalData"
      />
    </div>
    <pagination
      v-if="defaultData.length >= 50"
      class="flexbox justify-center mr-t-10"
      :totalPage="totalPage"
      :currentPage="currentPage"
      :paginationStorageKey="paginationStorageKey"
      @updateCurrentPage="updateCurrentPage"
    />
  </div>
</template>
<script>
import GetData from './FetchDataClient'
import Pagination from './PaginationNextPage'
import DatePicker from 'vue2-datepicker'

export default {
  components: {
    DatePicker,
    GetData,
    Pagination
  },
  data () {
    return {
      column: null,
      sort: null,
      pageData: [],
      defaultData: [],
      originalData: [],
      search: this.searchValue || null,
      keyword: this.searchValue || null,
      initial: true,
      start: null,
      end: null,
      detail: null,
      mall: null,
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      checkAll: false,
      totalPage: 0,
      currentPage: 1,
      isLoadMore: false
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    columns: {
      type: Array
    },
    isSearchable: {
      type: Boolean,
      default: false
    },
    tableClass: {
      type: String,
      default: ''
    },
    searchValue: {
      type: String,
      default: ''
    },
    extraUrl: {
      type: Array
    },
    extraUrlMode: {
      type: Boolean,
      default: false
    },
    method: {
      type: String,
      default: 'get'
    },
    malls: {
      type: Array,
      default: null
    },
    checkedItems: {
      type: Array,
      default () {
        return []
      }
    },
    isShowBtnBulkDelete: {
      type: Boolean,
      default: false
    },
    paginationStorageKey: {
      type: String,
      default: ''
    }
  },
  computed: {
    maxRows () {
      return this.$store.getters.getPaginationRow(this.paginationStorageKey)
    }
  },
  methods: {
    closePopup (dom) {
      dom.closePopup()
    },
    getOriginalData (data) {
      this.originalData = [...data]
    },
    /*
     * Handle on page change
     *
     * @param {Array} data All Data for table from API
     * @param {Object} extraData Extra data get from API
     *
     * @return void
     */
    onChangePage (data, keepSort) {
      this.defaultData = [...data]
      if (keepSort) {
        this.defaultData = this.defaultSort()
      } else {
        this.column = null
        this.name = null
      }
      this.pageData = this.defaultData.slice(0, 100)
      this.$emit('countData', this.countTableData())
      if (this.initial) {
        this.initial = false
      }
      this.isLoadMore = false
    },
    loadMoreData () {
      if (this.isLoadMore) {
        return false
      }
      const scrollPosition = window.innerHeight + window.scrollY
      const bottomPosition = document.documentElement.scrollHeight
      if (bottomPosition / 2 - scrollPosition < 0) {
        this.isLoadMore = true
        const loadDataRow = 100
        const startIndex = this.pageData.length
        if (startIndex >= this.defaultData.length) {
          return false
        }
        const endIndex = startIndex + loadDataRow
        const loadMoreData = [...this.defaultData].slice(startIndex, endIndex)
        setTimeout(() => {
          this.isLoadMore = false
        }, 500)
        this.pageData = [...this.pageData, ...loadMoreData]
        loadMoreData.length = 0
      }
    },
    /*
     * Render icon sort for each sort type of column (only for sortable column)
     *
     * @param {String} name Column's name
     *
     * @return {String}
     */
    iconSort (name) {
      if (this.column === name && this.sort) {
        return this.sort === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
      }
      return 'fa-sort'
    },
    /*
     * Handle onclick sort data
     *
     * @param {String} name Column's name
     * @param {Boolean} sortable Column is sortable or not
     * @param {Function} customSort Column is sortable or not
     *
     * @return void
     */
    sortColumn (name, sortable, customSort) {
      if (name === 'checkBoxAll') {
        this.checkAll = !this.checkAll
        this.$emit('checkBoxAll', this.checkAll)
      }
      if (!this.isSortable(sortable) || this.defaultData.length <= 1) return
      if (this.column !== name) this.sort = null
      this.column = name
      if (!this.sort) {
        this.sort = 'desc'
      } else if (this.sort === 'desc') {
        this.sort = 'asc'
      } else {
        this.sort = null
      }
      this.pageData = customSort ? customSort(this.defaultData, this.sort, name) : this.reOrderData(name, this.sort)
    },
    /*
     * Reorder data by current choosen column with approriate sort type
     *
     * @param {String} name Column's name
     * @param {String} order Sort's type (asc / desc / null)
     *
     * @return {Array}
     */
    reOrderData (name, order) {
      if (!order) {
        return [...this.defaultData]
      } else if (order === 'desc') {
        return [...this.defaultData].sort((before, after) => this.orderCallback(after, before, name))
      }
      return [...this.defaultData].sort((before, after) => this.orderCallback(before, after, name))
    },
    /*
    /*
     * Handle change data from parent component
     *
     * @param {Object} item Record to be changed
     * @param {String} type Type of changed
     * @param {Boolean} isCallApi Need to call API
     *
     * @return void
     */
    handleData (item, type) {
      this.$refs.pagination.handleData(item, type)
    },
    /*
    /*
     * Ordering callback
     *
     * @param {Object} before Left item
     * @param {Object} after Right item
     * @param {String} name Column's name
     *
     * @return {Boolean}
     */
    orderCallback (before, after, name) {
      return (
        (!isNaN(before[name]) && !isNaN(after[name])) ||
        (typeof before[name] === 'undefined' || typeof after[name] === 'undefined')
      ) ? before[name] - after[name] : ((after[name] === null) - (before[name] === null)) || before[name].localeCompare(after[name])
    },
    /*
     * Check column is sortable or not
     *
     * @param {Boolean} sortable Column sortable declaration
     *
     * @return {Boolean}
     */
    isSortable (sortable) {
      return sortable || typeof sortable === 'undefined'
    },
    /*
     * Initial sort when data changed
     *
     * @return {Array}
     */
    defaultSort () {
      const columnCustomSort = this.columns.filter((column) => column.name === this.column && column.customSort)
      return columnCustomSort.length > 0 ? columnCustomSort[0].customSort(this.defaultData, this.sort, name) : this.reOrderData(this.column, this.sort)
    },
    renderTitle (column) {
      let icon = this.isSortable(column.sortable) ? this.renderIconTag(['fa', this.iconSort(column.name)]) : ''
      return column.title + ' ' + icon
    },
    renderIconTag (classes) {
      return `<i class="${classes.join(' ')}"></i>`
    },
    countTableData () {
      if (this.defaultData === null) {
        return 0
      }
      return this.defaultData.length
    },
    onHandleSearchWithEnter (e) {
      if (e.keyCode !== 13) return

      this.onHandleSearch()
    },
    /*
     * Handle onclick search button
     *
     * @return void
     */
    onHandleSearch () {
      this.keyword = this.search
      this.$emit('keyword', this.keyword)
    },
    reload () {
      this.$refs.pagination.reload()
    },
    bgColor (judgmentStatusCode) {
      if (judgmentStatusCode === '8' || judgmentStatusCode === '9') {
        return 'bg-danger'
      }
    },
    selectRowRequest (event) {
      this.$emit('clickRow', event)
    },
    bulkAdd () {
      this.$emit('bulkAdd')
    },
    updateCurrentPage (val) {
      this.currentPage = val
    },
    updateTotalPage (val) {
      this.totalPage = val
    }
  },
  mounted () {
    $('.datepicker-start .mx-input-append').click((evt) => {
      $('.datepicker-start .mx-input').focus()
    })
    $('.datepicker-end .mx-input-append').click((evt) => {
      $('.datepicker-end .mx-input').focus()
    })
    window.addEventListener('scroll', this.loadMoreData)
  },
  unmouted () {
    window.removeEventListener('scroll', this.loadMoreData)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.loadMoreData)
  },
  watch: {
    search () {
      if (this.isSearchable) {
        this.$emit('onChangeSearch', this.search)
      }
    },
    searchValue () {
      this.keyword = this.searchValue
    },
    checkedItems: {
      handler (arrCheckedItems) {
        this.checkAll = arrCheckedItems.length > 0 && arrCheckedItems.length === this.defaultData.length
        $('#checkbox-all').prop('checked', this.checkAll)
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.search-block {
  margin-right: unset;
}
.search-block-detail {
  min-width: 400px;
  width: 100%;
  max-width: 400px;
}
@media (min-width: 1920px) {
  .search-block-detail {
    max-width: 500px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BaseTableClient.vue